module.exports = __webpack_public_path__ + "img/banner_left.f9b6ceae.png";